import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { BettyIgoLogo, Button } from '@betty/moonlight';
import { Modal } from '@betty/navigation';

import styles from './AuthHeader.module.css';

function AuthHeader() {
  const navigate = useNavigate();

  const onLoginPress = useCallback(() => {
    Modal.open({
      namespace: 'auth',
      type: 'Auth',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  }, []);

  const onJoinPress = useCallback(() => {
    navigate('/register');
  }, [navigate]);

  const onBettyPress = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const onIgoPress = useCallback(() => {
    window.open('https://igamingontario.ca/en', '_blank');
  }, []);

  return (
    <div className={styles.authHeader}>
      <BettyIgoLogo onBettyPress={onBettyPress} onIgoPress={onIgoPress} />
      <div className={styles.buttons}>
        <Button
          flex={1}
          variant="secondary"
          locNS="auth"
          locKey="login"
          onPress={onLoginPress}
        />
        <Button
          flex={1}
          variant="primary"
          locNS="auth"
          locKey="join"
          onPress={onJoinPress}
        />
      </div>
    </div>
  );
}

export default memo(AuthHeader);
